// Company info + legal links shown at the bottom of every portal page.
// The legal pages are served by the api Worker, so the links are absolute —
// reuse the same API base the portal already talks to (this codebase runs at
// more than one live domain; see docs/AWS-ISTANBUL-SINGLE-MACHINE.md) rather
// than a second hardcoded literal that could drift from it.
import { BASE as SITE } from "../api";

const LINKS: ReadonlyArray<readonly [string, string]> = [
  ["/iletisim", "İletişim"],
  ["/gizlilik", "Gizlilik Politikası"],
  ["/kvkk", "KVKK Aydınlatma Metni"],
  ["/cerez-politikasi", "Çerez Politikası"],
  ["/kosullar", "Kullanıcı Sözleşmesi"],
  ["/mesafeli-satis", "Mesafeli Satış Sözleşmesi"],
  ["/iptal-iade", "İptal ve İade Koşulları"],
];

const LEGAL_NAME = "MIOE ELEKTRONİK VE YAZILIM MÜHENDİSLİK LİMİTED ŞİRKETİ";

export function Footer() {
  return (
    <footer className="site-foot">
      <div className="site-foot-inner">
        <div className="site-foot-company">
          <div className="site-foot-name">{LEGAL_NAME}</div>
          <div>Koşuyolu Mah. Uygar Sk. Ender Apt. No:3, 34718 Kadıköy / İstanbul</div>
          <div>
            Tel: <a href="tel:+902166062205">0216 606 22 05</a> · E-posta:{" "}
            <a href="mailto:info@mioe.com.tr">info@mioe.com.tr</a>
          </div>
          <div>VKN: 6201259740 · MERSİS: 0620125974000001 · Tic. Sicil No: 281708-5</div>
        </div>
        <nav className="site-foot-links" aria-label="Hukuki sayfalar">
          {LINKS.map(([href, label]) => (
            <a key={href} href={`${SITE}${href}`}>
              {label}
            </a>
          ))}
        </nav>
      </div>
      <div className="site-foot-copy">
        <img
          className="site-foot-pay"
          src="https://static.wixstatic.com/media/33e6f0_2a26db0cdd644212b6eeaa6b55fbead0~mv2.png/v1/fill/w_560,h_42,al_c,lg_1,q_85,enc_avif,quality_auto/iyzico-logo-baad7d30.png"
          alt="iyzico ile güvenli ödeme"
          height={26}
          loading="lazy"
        />
        © {new Date().getFullYear()} {LEGAL_NAME} · Tüm hakları saklıdır.
      </div>
    </footer>
  );
}
